import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const EndUsersList = Loadable(
	lazy(() => import('modules/EndUsersManagement/pages/EndUsersList')),
);

const EndUserDetails = Loadable(
	lazy(() => import('modules/EndUsersManagement/pages/EndUserDetails')),
);

const EndUserProfile = Loadable(
	lazy(() => import('modules/EndUsersManagement/pages/EndUserProfile')),
);

const EndUserProgress = Loadable(
	lazy(() => import('modules/EndUsersManagement/pages/EndUserProgress')),
);

const EndUserOnboardingQuestions = Loadable(
	lazy(
		() => import('modules/EndUsersManagement/pages/EndUserOnboardingQuestions'),
	),
);

const END_USERS_MANAGEMENT_ROUTES: IRoute[] = [
	{
		path: 'end-users',
		element: EndUsersList,
		name: 'EndUsersList',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: 'end-users/:endUserId',
		element: EndUserDetails,
		name: 'EndUserDetails',
		roles: [ROLES.ADMIN],
		private: true,

		children: [
			{
				path: 'profile',
				element: EndUserProfile,
				name: 'EndUserProfile',
				roles: [ROLES.ADMIN],
				private: true,
			},
			{
				path: 'progress',
				element: EndUserProgress,
				name: 'EndUserProgress',
				roles: [ROLES.ADMIN],
				private: true,
			},
			{
				path: 'onboarding-questions',
				element: EndUserOnboardingQuestions,
				name: 'EndUserOnboardingQuestions',
				roles: [ROLES.ADMIN],
				private: true,
			},
		],
	},
];

export default END_USERS_MANAGEMENT_ROUTES;
